// init and options
var sound = new Howl({
  src: ['assets/mp3/bologna.mp3'],
  loop: true,
  volume: 0.4,
});

// start playing bologna song
function playBologna() {
  sound.play();
}

$('.first-icon').click(function () {
   $('.first-icon').toggleClass('hide');
   $('.second-icon').toggleClass('hide');
  playBologna();
})


// stop playing bologna song
function stopBologna() {
  sound.stop();
}


$('.second-icon').click(function () {
       $('.second-icon').toggleClass('hide');
   $('.first-icon').toggleClass('hide');
  stopBologna();
})






// WEBPACK FOOTER //
// ./assets/js/features/howlersetup.js